import { Date } from 'utils/global';
import { LiveEventTime } from './../state/types';
import timeZones from './time-zones';

const dateFormatOptions: Intl.DateTimeFormatOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
};

export function getClientLocalTimeZone(): string {
  return Intl.DateTimeFormat?.().resolvedOptions?.().timeZone || 'UTC';
}

export function stringifyGMTOffset(offset: number): string {
  const offsetSign = offset < 0 ? '-' : '+';
  const minutes = (offset % 1) * 60;
  const hours = Math.abs(Math.floor(offset));

  return `GMT ${offsetSign}${hours > 9 ? hours : `0${hours}`}:${
    minutes > 9 ? minutes : `0${minutes}`
  }`;
}

export function parseEventTime(eventTime: LiveEventTime): Date {
  const { time, date = 0, hour = 0, minute = 0 } = eventTime;

  // TODO: For now it's disabled cause it it's not precised.
  if (false) {
    return new Date(time * 1000);
  } else {
    const formattedDate = new Date(date * 1000);
    return new Date(
      Date.UTC(
        formattedDate.getUTCFullYear(),
        formattedDate.getUTCMonth(),
        formattedDate.getUTCDate(),
        hour,
        minute
      )
    );
  }
}

export function nativeDateToLiveEventTime(date: Date): LiveEventTime {
  const utcString = date.toUTCString();
  const utcDate = new Date(utcString);
  const utcMilliseconds = Date.parse(utcString);
  let utcDateMilliseconds = utcDate.setUTCHours(0);
  utcDateMilliseconds = utcDate.setUTCMinutes(0);

  return {
    time: utcMilliseconds / 1000,
    date: utcDateMilliseconds / 1000,
    hour: date.getUTCHours(),
    minute: date.getUTCMinutes()
  };
}

export function stringifyDateByTimeZone(eventTime: LiveEventTime, tz: string): string {
  const timeZone = tz || 'UTC';
  const timeOptions = {
    ...dateFormatOptions,
    timeZone
  };

  return parseEventTime(eventTime).toLocaleString('en-US', timeOptions);
}

export function stringifyUpdatedAtTime(updateTime: number, tz: string): string {
  if (!updateTime) {
    return '';
  }

  return new Date(updateTime * 1000)?.toLocaleString('en-US', dateFormatOptions);
}

export function getTimeZoneLabel(timezone: string): string {
  return timeZones.find((tz: any) => tz.name === timezone)?.label || 'Coordinated Universal Time';
}
